import { cx, styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";

import { Divider } from "../divider";
import { headingBaseClass } from "../header/Header.styles";
import { Icon } from "../icon";
import type { UiColorPalette } from "../utils/UIContext";
import { SIZE_FONT } from "../utils/colors";
import { type UiPaletteKey, resolveUiPalette } from "../utils/uiPalette";
import type { MessageProps, MessageSize } from "./Message.types";

type StyleProps = { $color: UiColorPalette; $size?: MessageSize };

const StyledMessage = styled.div<StyleProps>`
  position: relative;
  min-height: 1em;
  margin: 1em 0;
  background: ${({ $color }) => $color.softer};
  padding: 1em 1.5em;
  line-height: 1.4em;
  color: ${({ $color }) => $color.ink};
  transition: opacity 0.1s ease;
  border-radius: 0.28571429rem;
  box-shadow: 0 0 0 1px ${({ $color }) => $color.strong} inset;
  font-size: ${({ $size }) => ($size && SIZE_FONT[$size]) || "1em"};

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  > .${headingBaseClass} {
    margin-top: 0;
  }

  ${Divider} {
    border-color: ${({ $color }) => $color.strong};
  }

  ${Icon} {
    font-size: 1.1em;
    opacity: 0.8;
  }

  > ${Icon} {
    position: absolute;
    top: 7px;
    right: 6px;
  }
`;

const MessageComponent = ({
  color,
  size,
  children,
  className,
  style,
}: MessageProps) => {
  const theme = useTheme();
  const palette = resolveUiPalette(theme, (color ?? "grey") as UiPaletteKey);

  return (
    <StyledMessage
      className={cx(className)}
      style={style}
      role="status"
      $color={palette}
      $size={size}
    >
      {children}
    </StyledMessage>
  );
};

export const Message = styled(MessageComponent)``;
